// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"D0-z","displaySixCardTiles":"E0-z"};